import { render, staticRenderFns } from "./SideNavBar.vue?vue&type=template&id=5e534566&scoped=true"
import script from "./SideNavBar.vue?vue&type=script&lang=js"
export * from "./SideNavBar.vue?vue&type=script&lang=js"
import style0 from "./SideNavBar.vue?vue&type=style&index=0&id=5e534566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e534566",
  null
  
)

export default component.exports